import { calendarModel } from 'APP/model/model';
import Entities from 'STORE';

export const setCompactView = async (isCompact: boolean): Promise<void> => {
  try {
    await calendarModel.setCompactViewCalendar({ isCompact });
    Entities.calendar.setIsCompactViewEnabled(isCompact);
  } catch (error) {
    return;
  }
};
